import {ModalProps} from "react-bootstrap/Modal";
import {Form, Modal} from "react-bootstrap";
import React, {FC, memo, useCallback, useEffect, useState} from "react";
import {useDispatch} from "react-redux";
import {AppDispatch} from "../../store/configureStore";
import {
    fetchAddFileToPublicLink,
    fetchDeletePublicLinkFile,
    fetchFile2PublicLink,
    fetchPublicLinks
} from "../../fetch/PublicLinks";
import {ILinks} from "../../page/settings/PageSettings";
import {config} from "../../config";
import {Copy} from "react-bootstrap-icons";
import {Clipboard} from 'ts-clipboard';
import {ModalAccessContainer, ModalAccessFormCheck, ModalAccessLink} from "./ModalAccessStyle";


const ModalAccess: FC<ModalProps> = (props) => {
    const {fileId, onHide, show} = props
    const dispatch = useDispatch<AppDispatch>();

    const [links, setLinks] = useState<ILinks[]>([] as ILinks[])

    const [fileLinks, setFileLinks] = useState<ILinks[]>([] as ILinks[])

    const updateFile2PublicLink = useCallback((fileId: number) => {
        fetchFile2PublicLink(fileId).then(resp => {
            if (resp.status === 200) {
                setFileLinks(resp.data)
            }
        })
    }, [])

    useEffect(() => {
        if (show && fileId != null) {
           fetchPublicLinks().then(resp => {
               if (resp.status === 200) {
                   setLinks(resp.data)
               }
           })
            updateFile2PublicLink(fileId)
        }
    }, [show, fileId])




    const linkFile = useCallback((name: string, fileId: number) => {
        if (fileLinks.filter(filelink => filelink.name === name).length > 0) {
            fetchDeletePublicLinkFile(name, fileId).then(resp => {
                if (resp.status === 204) {
                    updateFile2PublicLink(fileId)
                }
            })
        } else {
            fetchAddFileToPublicLink(name, fileId).then(resp => {
                if (resp.status === 204) {
                    updateFile2PublicLink(fileId)
                }
            })
        }

    }, [fileLinks, links])


    return (
        <Modal
            {...props}
            size={"lg"}
               centered
        >
            <Modal.Header closeButton>
                Выбор ссылки для доступа
            </Modal.Header>
            <Modal.Body>
                <ModalAccessContainer>
                    {links.length === 0 && <span>Ссылок не найдено, создайте ссылку в настройках</span>}
                    {links.length > 0 && links.map((link) => {
                        return <ModalAccessLink>
                            <ModalAccessFormCheck // prettier-ignore
                                checked={fileLinks.filter(filelink => filelink.name === link.name).length > 0}
                                type={"checkbox"}
                                label={`/${link.name}`}
                                onChange={() => linkFile(link.name, fileId)}
                                color={link.enable ? "black" : "gray"}
                            />
                            <Copy onClick={() => Clipboard.copy(`${config.url}/public/files/${link.name}`)}/>
                        </ModalAccessLink>
                    })}
                </ModalAccessContainer>
            </Modal.Body>
        </Modal>
    );
}

export default memo(ModalAccess)
